import {REQUEST_TYPE} from '../../../constants';
import {doRequest} from '../../../helpers/network';
import {Cost} from '../../../helpers/Urls';

const INITIAL_STATE = {
  advanceConfigData: [],
  advanceConfigLoading: false,
  advanceConfigError: null,
  saveAdvanceConfigLoading: false,
  saveAdvanceConfigError: null,
  appliedFilters: {},
};

export const FETCH_ADVANCE_CONFIGS_COMPLETED = 'FETCH_ADVANCE_CONFIGS';
export const ADVANCE_CONFIG_LOADING = 'ADVANCE_CONFIG_LOADING';
export const ADVANCE_CONFIG_ERROR = 'ADVANCE_CONFIG_ERROR';
export const SAVE_ADVANCE_CONFIG_LOADING = 'SAVE_ADVANCE_CONFIG';
export const SAVE_ADVANCE_CONFIG_ERROR = 'SAVE_ADVANCE_CONFIG_ERROR';
export const SAVE_ADVANCE_CONFIG_COMPLETED = 'SAVE_ADVANCE_CONFIG_COMPLETED';
export const SET_APPLIED_ADVANCE_CONFIG_FILTERS =
  'SET_APPLIED_ADVANCE_CONFIG_FILTERS';

// Fetch configs with filters
export const getAdvanceConfigs = (page = 1, AdvConfigFilters) => async (
  dispatch,
) => {
  const {filterStr = ``} = AdvConfigFilters || {};
  dispatch({type: ADVANCE_CONFIG_LOADING});

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Cost.fetchAdvanceConfigsURL(page, filterStr),
    });
    const {data, status} = response || {};
    if (status) {
      dispatch({type: FETCH_ADVANCE_CONFIGS_COMPLETED, payload: data});
      return {success: true, data};
    } else {
      dispatch({
        type: ADVANCE_CONFIG_ERROR,
        error: response?.message || `Failed to fetch Advance Configs Data`,
      });
      return {
        success: false,
        message: response?.message || `Failed to fetch Advance Configs Data`,
      };
    }
  } catch (err) {
    dispatch({
      type: ADVANCE_CONFIG_ERROR,
      error: err,
    });
    return {
      success: false,
      message: err.message || 'Unexpected error occurred',
    };
  }
};

// Save (add / edit)
export const saveAdvanceConfig = (data, id) => async (dispatch) => {
  dispatch({type: SAVE_ADVANCE_CONFIG_LOADING});
  try {
    let response;
    if (id) {
      response = await doRequest({
        method: REQUEST_TYPE.PATCH,
        url: Cost.saveAdvanceConfigURL(id),
        data: data,
      });
    } else {
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Cost.saveAdvanceConfigURL(),
        data: data,
      });
    }
    if (response.status) {
      dispatch({type: SAVE_ADVANCE_CONFIG_COMPLETED, payload: response.data});
    } else {
      dispatch({type: SAVE_ADVANCE_CONFIG_ERROR, error: response.message});
    }
    return response;
  } catch (err) {
    dispatch({type: SAVE_ADVANCE_CONFIG_ERROR, error: err});
    return {
      status: false,
      message:
        err?.response?.data?.message || err.message || 'Something went wrong',
      error: err,
    };
  }
};

// reducers
export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case ADVANCE_CONFIG_LOADING:
      return {...state, advanceConfigLoading: true};
    case FETCH_ADVANCE_CONFIGS_COMPLETED:
      return {
        ...state,
        advanceConfigLoading: false,
        advanceConfigData: payload,
      };
    case ADVANCE_CONFIG_ERROR:
      return {...state, advanceConfigLoading: false, error: action.error};

    case SAVE_ADVANCE_CONFIG_LOADING:
      return {...state, saveAdvanceConfigLoading: true};
    case SAVE_ADVANCE_CONFIG_COMPLETED: {
      const newConfig = payload; // response.data from POST or PUT
      const prevData = state.advanceConfigData?.data || [];

      const index = prevData.findIndex((item) => item?.id === newConfig?.id);

      let updatedData;
      if (index >= 0) {
        // PUT: replace existing object
        updatedData = [...prevData];
        updatedData[index] = newConfig;
      } else {
        // POST: append new object
        updatedData = [newConfig, ...prevData];
      }
      return {
        ...state,
        saveAdvanceConfigLoading: false,
        advanceConfigData: {
          ...state.advanceConfigData,
          data: updatedData,
        },
      };
    }
    case SAVE_ADVANCE_CONFIG_ERROR:
      return {...state, saveAdvanceConfigLoading: false, error: action?.error};

    default:
      return {
        ...state,
      };
  }
};
